import { AxiosError } from "axios";
import {
    useQuery,
    useMutation,
} from "@tanstack/react-query";
import { Service } from "@/types";
import { ApiResponse } from "@/types/fetch.type";
import axios from "@/axios.config";

interface AllServicesParams {
    enabled?: boolean;
}
export const useGetAllServices = ({ enabled = true }: AllServicesParams) => {
    return useQuery<ApiResponse<Service[]>, AxiosError>({
        queryKey: ["services"],
        queryFn: async () => {
            const response = await axios.get<ApiResponse<Service[]>>("/services");
            return response.data;
        },
        enabled: enabled,
    });
}

export const useCreateService = () => {
    return useMutation<ApiResponse<Service>, AxiosError<{ message: string }>, Omit<Service, "id" | "dependentServices"> & { dependentServiceIds: string[] }>({
        mutationFn: async (service) => {
            const response = await axios.post<ApiResponse<Service>>("/services", service);
            return response.data;
        },
    });
}


interface ServicesByCouncilParams {
    enabled?: boolean;
    councilId?: string;
}

export const useGetServicesByCouncil = ({ councilId, enabled = true }: ServicesByCouncilParams) => {
    return useQuery<ApiResponse<Service[]>, AxiosError>({
        queryKey: ["services", councilId],
        queryFn: async () => {
            const response = await axios.get<ApiResponse<Service[]>>(`/services/council/${councilId}`);
            return response.data;
        },
        enabled: enabled && !!councilId,
    });
}

export const useGetServiceById = (serviceId: string) => {
    return useQuery<ApiResponse<Service>, AxiosError>({
        queryKey: ["services", serviceId],
        queryFn: async () => {
            const response = await axios.get<ApiResponse<Service>>(`/services/${serviceId}`);
            return response.data;
        },
    });
}

export const useUpdateService = () => {
    return useMutation<ApiResponse<Service>, AxiosError<{ message: string }>, Omit<Service,"dependentServices">>({
        mutationFn: async (service) => {
            const response = await axios.put<ApiResponse<Service>>(`/services/${service.id}`, service);
            return response.data;
        },
    });
}

export const useDeleteService = () => {
    return useMutation<ApiResponse<Service>, AxiosError<{ message: string }>, string>({
        mutationFn: async (serviceId) => {
            const response = await axios.delete<ApiResponse<Service>>(`/services/${serviceId}`);
            return response.data;
        },
    });
}